import * as React from "react";
import { forwardRef } from "react";
const ErrorCircleFillIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 16 16",
  "data-category": "validation",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fill: "#D63442",
  d: "M0 8c0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8 0 4.4183-3.5817 8-8 8-4.41828 0-8-3.5817-8-8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M10.4051 6.2622c.1649-.17574.1561-.45189-.0197-.61679-.1757-.1649-.45187-.15611-.61677.01964L8.07127 7.4741 6.2622 5.77673c-.17575-.1649-.4519-.15611-.6168.01964s-.1561.4519.01965.6168l1.80906 1.69738L5.77675 9.9196c-.1649.1757-.1561.4519.01965.6168s.4519.1561.61679-.0197l1.69737-1.809 1.80903 1.6974c.17571.1649.45191.1561.61681-.0197.1649-.1757.1561-.45189-.0197-.61679L8.70771 8.07126z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(ErrorCircleFillIcon);
ForwardRef.category = "validation";
export { ForwardRef as ErrorCircleFillIcon };